import { OfflineError } from "@sportactics/errors";

import {
  CredentialAlreadyInUseError,
  InvalidEmailError,
  PopupBlockedError,
  SignInCancelledError,
  TooManyAttemptsError,
  WeakPasswordError,
  WrongCredentialsError,
} from "~applications";

import { getFirebaseErrorCode } from "../get-firebase-error-code";
import { isFirebaseOfflineError } from "../is-firebase-offline-error";

export function mapSignInError(error: unknown): unknown {
  if (isFirebaseOfflineError(error)) return new OfflineError();

  switch (getFirebaseErrorCode(error)) {
    case "auth/popup-closed-by-user":
    case "auth/cancelled-popup-request":
    case "auth/user-cancelled":
      return new SignInCancelledError();
    case "auth/popup-blocked":
      return new PopupBlockedError();
    case "auth/invalid-credential":
    case "auth/invalid-login-credentials":
    case "auth/wrong-password":
    case "auth/user-not-found":
      return new WrongCredentialsError();
    case "auth/credential-already-in-use":
    case "auth/email-already-in-use":
    case "auth/account-exists-with-different-credential":
      return new CredentialAlreadyInUseError(getErrorEmail(error));
    case "auth/weak-password":
    case "auth/password-does-not-meet-requirements":
      return new WeakPasswordError();
    case "auth/invalid-email":
      return new InvalidEmailError();
    case "auth/too-many-requests":
      return new TooManyAttemptsError();
    default:
      return error;
  }
}

// The web SDK attaches the conflicting email to the error; native errors carry none.
function getErrorEmail(error: unknown): string | undefined {
  if (typeof error !== "object" || error === null) return undefined;
  const { customData } = error as { customData?: { email?: unknown } };
  return typeof customData?.email === "string" ? customData.email : undefined;
}
